const apis = {
  population: '/csv/population.csv',
  married: '/csv/married.csv',
  divorce: '/csv/divorce.csv',
  privateEduPrice: '/csv/privateEdu.csv',
  housePrice: '/csv/housePrice.csv',
  marrySurvey: '/csv/marrySurvey.csv',
  priceIndex: '/csv/priceIndex.csv', // 물가지수
  wage: '/csv/wage.csv',
  apartPrice: '/csv/apartPrice.csv',
  aging: '/csv/aging.csv',
  agingIndex: '/csv/agingIndex.csv',
  population_pyramid: '/csv/population_pyramid.csv',
  populationArchitecture: '/csv/population_architecture.csv',
};

export default apis;
